import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { localizedWeekday } from 'i18n/formatDate'
import { Controller, useForm } from 'react-hook-form'
import { components } from 'react-select'
import { Tooltip } from 'react-tooltip'
import TrashIcon from 'assets/svgs/TrashIcon.svg'

import 'react-tooltip/dist/react-tooltip.css'
import ClockIcon from 'components/Common/SvgIcons/ClockIcon'
import SelectField from 'components/Common/SelectField'
import Button from 'components/Common/Button'
import Grid from 'components/Common/Grid'
import {
  TimeSlotPlusButton,
  TimeSlotSelectFieldWrapper,
  TimeSlotTrashButton,
  TimeSlotUnavailable,
  TimeSlotUnavailableTitle,
  TimeSlotWrapper,
  ToolTipWrapper,
} from 'components/Calendar/EventForm/style'
import { getTimeOptions } from 'components/Calendar/EventForm/helper'
import { ITimeSlotOption } from 'components/Calendar/EventForm'

const Slots = ({
  parentIndex,
  field,
  timeSlots,
  handleSetValue,
  timeSlotOptions,
  handleSlotChange,
}) => {
  const { control } = useForm()

  const addNewSlot = () => {
    let isChecked = timeSlots[parentIndex].checked

    let endTime = timeSlots[parentIndex].slots.find((slot) => !slot.endTime)
    if (isChecked && endTime) return

    handleSetValue(true, timeSlots, parentIndex)
  }

  const removeSlot = (childIndex) => {
    let timeSlotLength = timeSlots[parentIndex].slots.length
    if (!timeSlotLength) return

    timeSlots[parentIndex].slots[childIndex].startTime = ''
    timeSlots[parentIndex].slots.splice(childIndex, 1)
    handleSetValue(false, timeSlots, parentIndex)
  }

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <ClockIcon />
      </components.DropdownIndicator>
    )
  }

  const { t, i18n } = useTranslation()
  const timeSlotsOptions: ITimeSlotOption[] = useMemo(
    () => getTimeOptions(timeSlotOptions),
    [timeSlotOptions]
  )

  return (
    <TimeSlotWrapper>
      {!field.checked && (
        <TimeSlotUnavailable>
          <TimeSlotUnavailableTitle>
            {t('calendar.availability.unavailable')}
          </TimeSlotUnavailableTitle>
        </TimeSlotUnavailable>
      )}
      {field?.slots?.map((item, childIndex) => {
        return (
          <Grid
            className="flex justify-center items-center xs:pb-5 sm:py-1 sm:ml-6"
            key={childIndex}
          >
            <TimeSlotSelectFieldWrapper>
              <Controller
                control={control}
                defaultValue={item.startTime}
                name={`timeSlots.${parentIndex}.slots.${childIndex}.startTime`}
                render={({ field }) => (
                  <SelectField
                    {...field}
                    isSearchable={false}
                    components={{ DropdownIndicator }}
                    placeholder="8:00 AM"
                    value={item.startTime}
                    options={timeSlotsOptions}
                    onChange={(value) => {
                      handleSlotChange(parentIndex, childIndex, value, true)
                    }}
                  />
                )}
              />
            </TimeSlotSelectFieldWrapper>
            <label className="text-center">{t('calendar.availability.to')}</label>
            <TimeSlotSelectFieldWrapper>
              <Controller
                control={control}
                defaultValue={item.endTime}
                name={`timeSlots.${parentIndex}.slots.${childIndex}.endTime`}
                render={({ field }) => (
                  <SelectField
                    isSearchable={false}
                    components={{ DropdownIndicator }}
                    {...field}
                    value={item.endTime}
                    placeholder="5:00 PM"
                    options={timeSlotsOptions}
                    onChange={(value) => {
                      handleSlotChange(parentIndex, childIndex, value, false)
                    }}
                  />
                )}
              />
            </TimeSlotSelectFieldWrapper>
            {field?.slots.length > 1 && (
              <TimeSlotTrashButton>
                {/* check-button -- clean up custom styles */}
                <Button
                  variant="text"
                  type="button"
                  icon={TrashIcon}
                  className="xs:!p-0 sm:!p-2 focus:!border-0 w-full"
                  onClick={() => removeSlot(childIndex)}
                />
              </TimeSlotTrashButton>
            )}
          </Grid>
        )
      })}
      {field?.checked && (
        <TimeSlotPlusButton onClick={() => addNewSlot()}>
          <span
            data-tooltip-id={timeSlots[parentIndex]}
            data-tooltip-content={t('calendar.availability.addInterval', {
              day: localizedWeekday(timeSlots[parentIndex]?.value, i18n.language),
            })}
          >
            <ToolTipWrapper>
              <Tooltip id={timeSlots[parentIndex]} />
            </ToolTipWrapper>
            {/* check-button -- clean up custom styles */}
            <Button
              variant="text"
              leftIcon="plus-circle"
              className="xs:!p-0 sm:!p-2 focus:!border-0 w-full"
              type="button"
            />
          </span>
        </TimeSlotPlusButton>
      )}
    </TimeSlotWrapper>
  )
}

export default Slots
